import React from 'react';
import { useSelectedStoreName } from '../../stores/appStore';
import styles from './StoreNamePreview.scss';
import { SkeletonCard } from '../../components/SkeletonCard';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

export function StoreNamePreview() {
  const { t } = useTranslation();
  const storeName = useSelectedStoreName();

  return (
    <div className={styles.wrapper}>
      <div className={styles.browserFrame}>
        <div className={styles.browserHeader}>
          <div className={styles.dotsContainer}>
            <div className={`${styles.dot} ${styles.dotRed}`} />
            <div className={`${styles.dot} ${styles.dotOrange}`} />
            <div className={`${styles.dot} ${styles.dotGreen}`} />
          </div>
        </div>

        <div className={styles.browserContent}>
          <Box direction="vertical" gap={1} justifyItems="center">
            <Heading size="extraLarge" className={styles.text}>
              {storeName || t('store_name_preview.fallback_title')}
            </Heading>

            <Text weight="thin" className={styles.text}>
              {t('store_name_preview.description')}
            </Text>
          </Box>

          <div className={styles.skeletonGrid}>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        </div>
      </div>
    </div>
  );
}
